/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-09 15:28:44
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-09 15:30:02
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/service/option.service.ts
 */
import _ from 'lodash';
import { useState } from 'react';

function useOptionsService() {
  const [options, setOptions] = useState([]);

  const C = (option) => {
    const arr = _.cloneDeep(options);
    arr.push(option);
    setOptions(arr);
  };

  const U = (index, option) => {
    const arr = _.cloneDeep(options);
    arr[index] = option;
    setOptions(arr);
  };

  const R = (index?: number) => {
    return index >= 0 ? options[index] : options;
  };

  const D = (index: number) => {
    const arr = _.cloneDeep(options);
    arr.splice(index, 1);
    setOptions(arr);
  };

  return {
    options,
    setOptions,
    C,
    U,
    R,
    D,
  };
}

export default useOptionsService;
